import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { FormsyTextArea } from '@thanx/uikit/textarea'
import { ChevronDown } from 'baseui/icon'
import { StatefulMenu } from 'baseui/menu'
import { PLACEMENT, StatefulPopover } from 'baseui/popover'
import { withFormsy } from 'formsy-react'
import { PassDownProps } from 'formsy-react/dist/withFormsy'
import { buildTranslate } from 'locales'
import React, { useCallback, useEffect, useRef } from 'react'
import { mergeTags, Tag } from './helpers'

const t = buildTranslate(
  'cms.content.app_home_page.content.edit_block.content.personalized_text'
)

type Props = {
  name: string
  text: string
} & PassDownProps<string>

const TextInput = (props: Props) => {
  const { name, text, setValue } = props
  const textAreaRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    setValue(text)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleChange = useCallback(
    (value: string) => {
      setValue(value)
    },
    [setValue]
  )

  const insertMergeTag = useCallback(
    (tag: Tag) => {
      const textarea = textAreaRef.current
      if (!textarea) return

      const value = `{{${tag.key}}}`

      // Get the current cursor position
      const start = textarea.selectionStart
      const end = textarea.selectionEnd

      // Get the current value
      const currentValue = textarea.value

      // Create the new value with the merge tag inserted
      const newValue =
        currentValue.substring(0, start) + value + currentValue.substring(end)
      handleChange(newValue)

      setTimeout(() => {
        textarea.focus()
        const newCursorPosition = start + value.length
        textarea.setSelectionRange(newCursorPosition, newCursorPosition)
      }, 0)
    },
    [handleChange]
  )

  return (
    <>
      <Text.Header4 color="grey70" tag="p" className="mt-m">
        {t('custom_text')}
      </Text.Header4>
      <div className="d-flex align-items-end mb-2">
        <div className="flex-grow-1">
          <FormsyTextArea
            name={name}
            placeholder={t('enter_text_here')}
            value={text ?? ''}
            rows={4}
            onChange={handleChange}
            inputRef={textAreaRef}
          />
        </div>
      </div>
      <div className="d-flex justify-content-between mb-2">
        <div className="text-muted small mt-1">{t('markdown_supported')}</div>
        <StatefulPopover
          focusLock
          placement={PLACEMENT.bottomLeft}
          content={({ close }) => (
            <StatefulMenu
              items={mergeTags}
              onItemSelect={({ item }) => {
                insertMergeTag(item)
                close()
              }}
            />
          )}
        >
          <Button
            size={'small'}
            type={'button'}
            endEnhancer={() => <ChevronDown size={20} />}
          >
            {t('add_merge_tag')}
          </Button>
        </StatefulPopover>
      </div>
    </>
  )
}

export default withFormsy(TextInput)
